import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  standardColours,
  fontWeights,
  fontSize,
  visuallyHidden,
  standardTransition,
} from '../styles';

const StyledProductQuantity = styled.label`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${standardColours.lightGrey};
`;

const StyledText = styled.span`
  ${visuallyHidden()};
`;

const StyledQuantityWrap = styled.div`
  position: relative;
  padding: 0 ${({ isCartItem }) => (isCartItem ? '35' : '45')}px;
`;

const StyledQuantityButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  ${({ alt }) => (alt ? 'right: 0' : 'left: 0')};
  width: ${({ isCartItem }) => (isCartItem ? '35' : '45')}px;
  background: ${standardColours.white};
  border: none;

  &:before {
    content: ${({ alt }) => (alt ? '"+"' : '"-"')};
    font-weight: ${fontWeights.bold};
    ${({ isCartItem }) => (isCartItem ? fontSize(24) : fontSize(32))};
    line-height: ${({ alt }) => (alt ? '1.1' : '0.9')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transition: ${standardTransition('opacity')};
  }
`;

const StyledQuantity = styled.input`
  height: ${({ isCartItem }) => (isCartItem ? '33' : '45')}px;
  width: ${({ isCartItem }) => (isCartItem ? '60' : '100')}px;
  font-weight: ${fontWeights.bold};
  ${({ isCartItem }) => (isCartItem ? fontSize(16) : fontSize(18))};
  text-align: center;
  background: ${standardColours.lightGrey};
  border: none;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`;

const ProductQuantity = ({
  quantity,
  quantityDiscounts,
  setQuantity,
  changeFunction,
  isCartItem,
  ...props
}) => {
  const minQuantity =
    parseInt(
      quantityDiscounts
        ?.find(quantityDiscount => quantityDiscount.split('|')[1] === '0')
        ?.split('|')[0],
    ) || 1;

  useEffect(() => {
    setQuantity(minQuantity);
  }, [minQuantity]);

  return (
    <StyledProductQuantity {...props}>
      <StyledText>Quantity</StyledText>
      <StyledQuantityWrap isCartItem={isCartItem}>
        <StyledQuantityButton
          type="button"
          value="remove"
          disabled={quantity <= minQuantity}
          isCartItem={isCartItem}
          onClick={changeFunction}
        >
          <StyledText>Remove One</StyledText>
        </StyledQuantityButton>
        <StyledQuantity
          type="number"
          name="quantity"
          value={quantity}
          min={minQuantity}
          required
          disabled={isCartItem}
          isCartItem={isCartItem}
          onChange={e => changeFunction(e, minQuantity)}
        />
        <StyledQuantityButton
          type="button"
          value="add"
          alt={true}
          isCartItem={isCartItem}
          onClick={changeFunction}
        >
          <StyledText>Add One</StyledText>
        </StyledQuantityButton>
      </StyledQuantityWrap>
    </StyledProductQuantity>
  );
};

export default ProductQuantity;
